export default "__VITE_ASSET__DsyklP2y__"